import { ComponentType, EventSource, InteractionType, MixpanelEvent } from '../MixPanelTypes';

export type QuickActionsEvents =
  | 'QUICK_ACTION_CREATE_REPORT'
  | 'QUICK_ACTION_ADD_WORKER'
  | 'QUICK_ACTION_IMPORT_DATA'
  | 'QUICK_ACTION_SUBMIT_REQUEST';

export const quickActionsEvents: Record<QuickActionsEvents, MixpanelEvent> = {
  QUICK_ACTION_SUBMIT_REQUEST: {
    eventDescription: 'Redirect to Submit Request page',
    eventKey: 'quick-action-sibmit-request',
    eventSource: EventSource.USER_INTERACTION,
    interactionType: InteractionType.CLICK,
    componentType: ComponentType.SUB_MENU_BUTTON
  },
  QUICK_ACTION_IMPORT_DATA: {
    eventDescription: 'Open Import Data dialog',
    eventKey: 'quick-action-import-data',
    eventSource: EventSource.USER_INTERACTION,
    interactionType: InteractionType.CLICK,
    componentType: ComponentType.SUB_MENU_BUTTON
  },
  QUICK_ACTION_CREATE_REPORT: {
    eventDescription: 'Redirect to the Create Report in My Report page',
    eventKey: 'quick-action-create-report',
    eventSource: EventSource.USER_INTERACTION,
    interactionType: InteractionType.CLICK,
    componentType: ComponentType.SUB_MENU_BUTTON
  },
  QUICK_ACTION_ADD_WORKER: {
    eventDescription: 'Redirect to the Add Worker page',
    eventKey: 'quick-action-add-worker',
    eventSource: EventSource.USER_INTERACTION,
    interactionType: InteractionType.CLICK,
    componentType: ComponentType.SUB_MENU_BUTTON
  }
} as const;
